import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./App";
import { ProvedorDeSessao } from "./api/sessao";
import "./estilo/tokens.css";

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("A âncora #raiz não existe no index.html.");

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorDeSessao>
        <App />
      </ProvedorDeSessao>
    </BrowserRouter>
  </StrictMode>,
);
